import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import { useRecaptcha } from 'data/useRecaptcha';
import { Listing } from 'graphql/generated';
import React, { useCallback, useEffect } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

import { buildSpecItem } from '../../common/components/SpecItem';

type Props = { listingId: string };
type ContactInfo = {
  email?: string;
  phone?: string;
};

const ItemContactInfo = (props: Props) => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const { verifyToken } = useRecaptcha();
  // const [checkComplete, checkCompleteTo] = React.useState(false);
  const [loading, loadingTo] = React.useState(true);
  const [valid, validTo] = React.useState(false);
  const [contactInfo, contactInfoTo] = React.useState<ContactInfo>({});
  const [runOnce, runOnceTo] = React.useState(true);

  const handleReCaptchaVerify = useCallback(async () => {
    if (!executeRecaptcha) {
      console.log('Execute recaptcha not yet available');
      return;
    }
    const token = await executeRecaptcha('verifyToken');
    // console.log('recaptcha token', token);
    // checkCompleteTo(true);
    const result = await verifyToken(token, props.listingId);
    validTo(result.valid);
    contactInfoTo({ email: result.email, phone: result.phone });
    loadingTo(false);
  }, [executeRecaptcha, verifyToken, props.listingId]);

  React.useEffect(() => {
    if (runOnce) {
      runOnceTo(false);
      handleReCaptchaVerify();
    }
  }, [runOnce, handleReCaptchaVerify]);

  const formatPhone = (phone: string) => {
    return `(${phone.substring(0, 3)}) ${phone.substring(3, 6)}-${phone.substring(6)}`;
  };

  return (
    <>
      {loading ? (
        <Box sx={{ display: 'flex', position: 'relative', top: '20%', left: '24%' }}>
          <CircularProgress color="secondary" />
        </Box>
      ) : (
        <>
          <Grid container>
            {contactInfo.email && buildSpecItem('Email', contactInfo.email, true)}
            {contactInfo.phone && buildSpecItem('Phone', formatPhone(contactInfo.phone))}
          </Grid>
        </>
      )}
    </>
  );
};

export default ItemContactInfo;
